var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGreeceIcon = function SvgGreeceIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#greece-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M14 10.348h13.518a14 14 0 0 0-1.573-3.652H14zM5.285 24.957h17.43a14.1 14.1 0 0 0 3.23-3.653H2.055a14.1 14.1 0 0 0 3.23 3.653M4.87 3.387a14 14 0 0 0-2.815 3.309h2.814z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M14 14v-3.652H8.522V14H4.87v-3.652H.482A14 14 0 0 0 0 14c0 1.264.168 2.488.482 3.652h27.036C27.832 16.488 28 15.264 28 14zM14 0c-1.944 0-3.795.397-5.478 1.113v5.583H14V3.043h8.715A13.94 13.94 0 0 0 14 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "greece-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
};
export default SvgGreeceIcon;